import React, { useState, useEffect, useRef } from 'react'
import {
  View,
  Keyboard,
  ScrollView,
  ViewStyle,
  StyleSheet,
  Platform
} from 'react-native'


type KeyboardDodgerProps = {
  children: React.ReactNode;
  style?: ViewStyle;
}

export const KeyboardDodger = ({ children, style }: KeyboardDodgerProps) => {
  const [height, setHeight] = useState<number>()

  const s = height ? { height } : { flex: 1 }

  const layoutHeight = useRef<number>()

  useEffect(() => {
    const showListener = Keyboard.addListener('keyboardDidShow', ev => {
      setHeight(layoutHeight.current - ev.endCoordinates.height)
    })

    const hideListener = Keyboard.addListener('keyboardWillHide', ev => {
      setHeight(layoutHeight.current)
    })

    return Platform.OS === 'web' ? undefined : () => {
      showListener.remove()
      hideListener.remove()
    }
  }, [])

  return (
    Platform.OS === 'web' ? <View style={style}>{children}</View> : (
      <View
        style={[s, style]}
        onLayout={ev => {
          if (!layoutHeight.current) {
            layoutHeight.current = ev.nativeEvent.layout.height
            setHeight(layoutHeight.current)
          }
        }}>
        <ScrollView style={styles.scroller}>
          {children}
        </ScrollView>
      </View>
    ) 
  )
}

export default KeyboardDodger

const styles = StyleSheet.create({
  scroller: {
    height: '100%',
    flex: 1,
    // backgroundColor: 'yellow',
    // borderColor: 'orange',
    // borderWidth: 1
  }
})